// @ts-check

/**
 * Bridge between Checkout's shared pay button and the mounted Basis Theory form.
 */
function BasisTheoryCheckoutEngine() {
  let registration = null;
  let status = 'unregistered';
  const listeners = new Set();

  /** Notify subscribers when the active checkout lifecycle changes. */
  function notifyStatusChange() {
    listeners.forEach((listener) => listener(status));
  }

  /** Register a mounted checkout form and return identity-safe lifecycle controls. */
  function registerSubmitHandler(handler, initialStatus = 'loading') {
    const nextRegistration = { handler };
    registration = nextRegistration;
    status = initialStatus;
    notifyStatusChange();

    return {
      /** Update status only while this registration is still active. */
      updateStatus(nextStatus) {
        if (registration !== nextRegistration || status === nextStatus) return;
        status = nextStatus;
        notifyStatusChange();
      },
      /** Remove this registration without clearing a newer mounted form. */
      unregister() {
        if (registration !== nextRegistration) return;
        registration = null;
        status = 'unregistered';
        notifyStatusChange();
      },
    };
  }

  /** Submit the mounted checkout form when one is registered. */
  function submit() {
    if (registration) return registration.handler();
    return undefined;
  }

  /** Read the active checkout lifecycle status. */
  function getStatus() {
    return status;
  }

  /** Subscribe to checkout lifecycle changes. */
  function subscribe(listener) {
    listeners.add(listener);
    listener(status);
    return () => listeners.delete(listener);
  }

  return { getStatus, registerSubmitHandler, submit, subscribe };
}

export default BasisTheoryCheckoutEngine();
